import styled from 'styled-components';

export const ButtonTextWrapper = styled.span`
    width: 100%;
    text-align: left;
`;
